import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import './plugins'
import CopyId from './components/global/CopyId.vue'

Vue.component('CopyId', CopyId)

import { router } from './router'
import store from './store'
import i18n from './i18n'

// Vue.prototype.$baseUrl = 'http://localhost:8000/api/'
Vue.prototype.$baseUrl = 'https://api.bahokcourier.com/api/'
Vue.prototype.$image_path = 'https://api.bahokcourier.com/';
Vue.config.productionTip = false
Vue.prototype.$axios = axios;

//if unauthenticated redirect to login page
axios.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response.status === 401) {
    this.$router.push('/login')
  }
  return error;
});

var vm = new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.vm = vm